/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Done_Metric_FailedInputs */

const cs_import_done_metric_failed = /** @type {(inputs: Import_Done_Metric_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selhalo`)
};

const en_import_done_metric_failed = /** @type {(inputs: Import_Done_Metric_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Import_Done_Metric_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_done_metric_failed = /** @type {((inputs?: Import_Done_Metric_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Done_Metric_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_done_metric_failed(inputs)
	return cs_import_done_metric_failed(inputs)
});